import React from "react";
import { makeStyles, Box, ListItemIcon } from "@material-ui/core";
import RoundedIcon from "./RoundedIcon";
import { COMPANY_FACEBOOK, COMPANY_LINKEDIN } from "../../config/constants";
import CustomImage from "../../components/CustomImage";

const useStyles = makeStyles(() => ({
  socialIcon: {
    maxHeight: 20,
    objectFit: "contain",
  },
}));

function FooterSocials() {
  const classes = useStyles();

  const SocialElement = ({ title, url, image }) => {
    return (
      <ListItemIcon style={{ minWidth: 0, marginLeft: 5, marginRight: 5 }}>
        <a target="_blank" rel="noopener noreferrer" href={url}>
          <RoundedIcon>
            <CustomImage
              src={image}
              className={classes.socialIcon}
              alt={title}
            />
          </RoundedIcon>
        </a>
      </ListItemIcon>
    );
  };

  return (
    <Box style={{ marginTop: 34 }}>
      <SocialElement
        title="Facebook"
        url={COMPANY_FACEBOOK}
        image={`${process.env.PUBLIC_URL}/assets/svgs/facebook.svg`}
      />

      <SocialElement
        title="Linkedin"
        url={COMPANY_LINKEDIN}
        image={`${process.env.PUBLIC_URL}/assets/svgs/linkedin.svg`}
      />
    </Box>
  );
}

export default FooterSocials;
